import React, { Component, useState } from 'react';
import { ValidatorForm } from 'react-form-validator-core';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SingleAssignmentFormPreview from './SingleAssignmentFormPreview';
import {
  Translate,
  TFVButton,
  RouteLeavingGuard,
  Modal,
  TextField,
} from '../../../Share/components';
import { createNewOrder } from '../../actions';
import history from '../../../Share/utils/history';
import { isIE } from '../../../Share/utils';
import { subscribe } from '../../actions/eventBus';
import SuccessMessage from './SuccessMessage';

import { updateOrder } from '../../actions/workAssignment';

const propTypes = {
  assignment: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  onCreateNewOrder: PropTypes.func,
  onUpdateOrder: PropTypes.func,
  isBasic: PropTypes.bool,
  onClose: PropTypes.func,
  createNewOrderError: PropTypes.arrayOf(PropTypes.shape({})),
  customerDefaultAddress: PropTypes.shape({}),
  customerName: PropTypes.string,
};

const defaultProps = {
  assignment: {},
  onClose: () => {},
  isBasic: false,
  onCreateNewOrder: () => {},
  onUpdateOrder: () => {},
  createNewOrderError: [],
  customerDefaultAddress: {},
  customerName: '',
};

class PreviewAssignment extends Component {
  state = {
    isDirty: true,
    orderEmail: '',
  };

  scrollRef = React.createRef();

  componentRef = React.createRef();

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.orderEmail === '') {
      return {
        ...prevState,
        orderEmail: nextProps.assignment.orderEmail,
      };
    }
    return null;
  }

  handleSubmit = async () => {
    const { assignment, handleConfirmDuplicateOrder } = this.props;
    const { orderEmail } = this.state;
    assignment.isBasic = this.props.isBasic;
    assignment.DoForce = 0;
    if (assignment.isEdit) {
      const response = await this.props.onUpdateOrder({
        ...assignment,
        orderEmail,
      });
    } else {
      const response = await this.props.onCreateNewOrder({
        ...assignment,
        orderEmail,
      });
      // if (!response) {
      //   handleConfirmDuplicateOrder(assignment, orderEmail);
      // }
      this.checkDuplicateOrder(assignment, orderEmail);
    }
  };

  checkDuplicateOrder = (assignment, orderEmail) => {
    let showduplicateOrder = false;
    let errorMessage = '';
    const { createNewOrderError, handleConfirmDuplicateOrder } = this.props;
    if (createNewOrder) {
      createNewOrderError.forEach(element => {
        if (element.ErrorCode === 1082) {
          showduplicateOrder = true;
          errorMessage = element.ErrorMessage;
        }
      });
    }
    if (showduplicateOrder) {
      handleConfirmDuplicateOrder(assignment, orderEmail, errorMessage);
    }
  };

  render() {
    const {
      assignment,
      onClose,
      isBasic,
      customerDefaultAddress,
      customerName,
    } = this.props;
    const { isDirty, orderEmail } = this.state;

    return (
      <>
        <div
          className={`d-flex flex-column tv-workassignment__modal-${
            isBasic ? 'scroll-container' : 'scroll-container'
          } tv-workassignment__modal-detail-contailer border-top-0`}
          ref={this.props.printRef}
        >
          {/* <Scrollbars ref={this.scrollRef}> */}

          <SingleAssignmentFormPreview
            {...assignment}
            showBasicPreview={isBasic}
            showEditButton
            isDirty={isDirty}
            changeIsDirty={(status, callback) => {
              this.setState({ isDirty: status }, callback);
            }}
            customerDefaultAddress={customerDefaultAddress}
            customerName={customerName}
          />
          {/* </Scrollbars> */}
        </div>

        <div className="d-flex flex-column tv-workassignment__modal-footer">
          <div className="tv-workassignment__detail-links ml-2 mt-2">
            <div
              onClick={this.props.handlePrint}
              /* <div className="tv-single-assign-form__preview-property mb-0 text-left">
              <div className="property-label">
                <Translate content="singleAssignment.orderContacEmail" />:
              </div>
              <ValidatorForm ref="form" onSubmit={() => {}}>
                <EditableField
                  value={orderEmail}
                  onChange={value => {
                    if (value != '') {
                      this.setState({
                        orderEmail: value,
                      });
                    }
                  }}
                  editableButtonclassName="tv-workassignment__detail-links-item tv-workassignment__detail-links-item-button my-1 p-0"
                  readOnlyClassName="property-value"
                />
              </ValidatorForm>
            </div> */
              className="tv-workassignment__detail-links-item justify-content-end mb-1"
            >
              {Translate({
                content: 'reportQuality.printButton',
              })}
            </div>
          </div>
          <div className="tv-workassignment__detail-buttons tv-display-flex">
            <TFVButton
              type="secondary"
              className="tv-single-assign-form__button-preview"
              buttonType="button"
              text={Translate({
                content: 'previewAssignment.confirmNow',
              })}
              onClick={this.handleSubmit}
            />
            <TFVButton
              type="line-primary"
              buttonType="button"
              className="w-50 ml-1"
              text={Translate({
                content: 'singleAssignment.goBack',
              })}
              onClick={e => {
                onClose();
              }}
            />
          </div>
        </div>
      </>
    );
  }
}

PreviewAssignment.propTypes = propTypes;
PreviewAssignment.defaultProps = defaultProps;

const mapStateToProps = state => {
  const { assignmentTemp, createNewOrderError } = state.workAssignment;
  const { customerName } = state.user.profile;
  const assignment = {
    ...assignmentTemp,
  };
  return {
    assignment,
    createNewOrderError,
    customerName,
  };
};

const mapDispatchToProps = dispatch => ({
  onCreateNewOrder: assignment => dispatch(createNewOrder(assignment)),
  onUpdateOrder: assignment => dispatch(updateOrder(assignment)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PreviewAssignment);

function EditableField({
  value,
  onChange,
  readOnlyClassName,
  editableButtonClass,
}) {
  const [editMode, seteditMode] = useState(false);
  const [fieldValue, setFieldValue] = useState(value);
  const [isFieldValid, setIsFieldValid] = useState(true);
  const handleValueChange = e => {
    setFieldValue(e.target.value);
  };
  return editMode ? (
    <div className="d-flex w-100">
      <div className="d-flex w-100 flex-column">
        <TextField
          type="email"
          onChange={handleValueChange}
          validatorListener={e => {
            if (e !== isFieldValid) {
              setIsFieldValid(e);
            }
          }}
          onBlur={() => {
            if (isFieldValid) {
              onChange(fieldValue);
              seteditMode(false);
            }
          }}
          className={readOnlyClassName}
          name="contact-email"
          value={fieldValue}
          validators={['isEmail']}
          errorMessages={[
            Translate({ content: 'validator.incorrectEmailFormat' }),
          ]}
        />
      </div>
      <TFVButton
        type="text"
        disable={!isFieldValid}
        className={editableButtonClass}
        buttonType="submit"
        text={Translate({
          content: 'general.save',
        })}
        onClick={() => {
          if (isFieldValid) {
            onChange(fieldValue);
            seteditMode(false);
          }
        }}
      />
    </div>
  ) : (
    <div className="d-flex">
      <div className={`${readOnlyClassName} edit-field`} title={value}>
        {value != '' && value ? value : '-'}
      </div>
      <TFVButton
        type="text"
        className={editableButtonClass}
        buttonType="button"
        text={Translate({
          content: 'general.edit',
        })}
        onClick={() => seteditMode(true)}
      />
    </div>
  );
}
